import { useEffect, useState } from 'react';
import { SWRConfiguration } from 'swr';

import { useChildRunsQueryParams } from '@/Pages/Run/utils/useChildRunsQueryParams';
import { useGroupChildByParentId } from '@/Pages/Run/utils/useGroupChildByParentId';
import { useRunsQuery } from '@/hooks/useSwr';
import { RunSchema } from '@/types/schema';

export function useThreadChildRuns({
  selectedRootRun,
  options,
  getChildIO = false,
}: {
  selectedRootRun?: RunSchema;
  getChildIO?: boolean;
  options?: SWRConfiguration;
}) {
  const [allChildRuns, setAllChildRuns] = useState<Record<string, RunSchema[]>>(
    {}
  );

  const childRunsQueryParams = useChildRunsQueryParams({
    rootRun: selectedRootRun,
    select: getChildIO ? ['inputs', 'outputs'] : undefined,
  });

  const childRuns = useRunsQuery(childRunsQueryParams, undefined, {
    keepPreviousData: true,
    ...options,
  });

  const childRunLookup = useGroupChildByParentId(
    childRuns.data?.runs,
    childRuns.isLoading
  );

  useEffect(() => {
    if (childRunLookup) {
      setAllChildRuns((prev) => ({
        ...prev,
        ...childRunLookup,
      }));
    }
  }, [childRunLookup]);

  return {
    data: allChildRuns,
    isLoading: childRuns.isLoading,
    error: childRuns.error,
  };
}
